import { useState, useCallback } from 'react';

export const useDelayedState = <T>(initialState: T, delay: number): [T, (newState: T) => void] => {
  const [state, setState] = useState<T>(initialState);

  const setDelayedState = useCallback(
    (newState: T) => {
      setTimeout(() => {
        setState(newState);
      }, delay);
    },
    [delay],
  );

  return [state, setDelayedState];
};
